import {
    apiRequest,
    pengalamanKerjaDetail,
    pengalamanKerjaApprove
} from "../../../../../services/adapters/kepegawaian/pengalamanKerjaService"

class ApproveRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", pengalamanKerjaDetail, {
            params: query
        }, true)
    }

    fetchApprove = async (query) => {
        return await apiRequest("post", pengalamanKerjaApprove, {
            body: query
        }, true)
    }
}

export default ApproveRepository